module.exports = __webpack_public_path__ + "img/s3-1.29edd7c2.jpg";